<template>
  <div :id="$options.name" class="heading">
    <div class="heading__wrap">
      <div class="heading__element heading__element--first">
        <div class="d-flex align-items-center">
          <div class="d-flex">
            <h1 class="heading__title">{{ property.name }}</h1>
            <b-form-rating
              class="heading__star"
              v-if="property.ratings && property.ratings.property"
              no-border inline readonly
              size="md"
              variant="secondary"
              :value="property.ratings.property.rating"
            />
          </div>
        </div>
        <div class="heading__address">
          <p class="heading__address-road">
            <vb-icon class="heading__icon mr-1" :color="sass('primary')" :name="'pin'" :size="13" />
            <span>
              {{ property.location.address + ', ' + property.location.zip + ' ' + property.location.city }}
            </span>
            <span class="heading__address-map" v-b-modal="'modal_map'">vedi su mappa</span>
          </p>
          <p class="heading__address-proximity">
            <vb-icon class="heading__icon mr-1" :color="sass('secondary')" :name="'compass'" :size="13" />
            <span>{{ property.descriptions.headline }}</span>
          </p>
        </div>
      </div>
      <div class="heading__element heading__element--second">
        <score class="heading__score" :rating="property.ratings.salabam_score" direction="row" />
        <router-link :to="{ name: 'detail', hash: '#rooms' }">
          <vb-button
            class="semibold"
            :vb_options="{
              text: 'Prenota Ora',
              variant: 'outline-primary',
              size: 'sm'
            }"
          />
        </router-link>
      </div>
    </div>
    <vb-modal
      :vb_options="{
        id: 'modal_map',
        size: 'xl',
        title: property.name,
        hide_footer: true,
      }"
    >
      <detail-google-map
        :map_markers="g_map.markers"
        :map_location="g_map.location"
      />
    </vb-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { map_markers_v3 } from '@liveeps/utilities'
import Score from "@liveeps/components/atoms/score"
import GoogleMap from '@components/blocks/map'

export default {
  inheritAttrs: false,
  name: 'heading',

  components: {
    'detail-google-map': GoogleMap,
    'score': Score,
  },

  props: {
    property: Object,
    availability: String,
  },

  data() {
    return {
    }
  },

  computed: {
    ...mapState({
      // liveeps
      selected_property: state => state.liveeps.selected_property,
    }),

    g_map() {
      return {
        markers: map_markers_v3([this.selected_property], this.availability, this.sass),
        location: {
          ...this.property.location.coordinates
        }
      }
    }
  },

  created() {
  },

  mounted() {
  },

  methods: {
  },
}
</script>

<style lang="scss" scoped>

  .heading {

    &__wrap {
      display: flex;
      justify-content: space-between;
      flex-direction: column;

      @include media-breakpoint-up(md){
        flex-direction: row;
        align-items: center;
      }
    }

    &__element {

      &--second {
        display: none;

        @include media-breakpoint-up(lg){
          display: block;
        }
      }
    }

    &__icon {
      &--like {
        background-color: $white;
        padding: 3px;
        border-radius: $border-radius-lg;
        margin-right: 10px;
      }
    }

    &__title {
      margin-bottom: 0;
    }

    &__star {
      margin-left: 5px;
      margin-top: -15px;
      width: auto;
    }

    &__address {

      @include media-breakpoint-up(md){
        display: flex;
        align-items: center;
      }

      &-road {
        display: flex;
        align-items: center;
        margin-bottom: 0;
      }

      &-proximity {
        display: flex;
        align-items: center;
        margin-bottom: 0;
        margin-top: $grid-gutter-width / 6;
        color: var(--secondary);
        font-size: $font-size-md;

        @include media-breakpoint-up(md){
          margin-left: $grid-gutter-width / 3;
          margin-top: 0;
        }
      }

      &-map {
        color: var(--info);
        margin-left: $grid-gutter-width / 4;
        text-decoration: underline;
        cursor: pointer;
      }
    }

    &__score {
      margin-bottom: 10px;
    }
  }

  .map {
    max-height: 80vh;
    height: 320px;
    @include media-breakpoint-up(sm) {
      height: 400px;
    }
    @include media-breakpoint-up(md) {
      height: 600px;
    }
  }

</style>